// frontend/src/components/Charts/SalesComparisonChart.jsx
// 🆕 GRÁFICA DE COMPARACIÓN DE VENTAS

import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const SalesComparisonChart = ({ data, type = 'monthly' }) => {
  const chartData = {
    labels: data.map(item => item.label),
    datasets: [
      {
        label: 'Propuestas',
        data: data.map(item => item.quotes),
        backgroundColor: 'rgba(94, 114, 228, 0.8)',
        borderColor: 'rgb(94, 114, 228)',
        borderWidth: 1,
      },
      {
        label: 'Órdenes',
        data: data.map(item => item.orders),
        backgroundColor: 'rgba(45, 206, 137, 0.8)',
        borderColor: 'rgb(45, 206, 137)',
        borderWidth: 1,
      },
      {
        label: 'Facturas',
        data: data.map(item => item.invoices),
        backgroundColor: 'rgba(251, 177, 64, 0.8)',
        borderColor: 'rgb(251, 177, 64)',
        borderWidth: 1,
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true,
          padding: 15,
          font: {
            size: 12
          }
        }
      },
      title: {
        display: true,
        text: type === 'monthly' ? 'Comparación Mensual' : 'Comparación por Período',
        font: {
          size: 16,
          weight: '600'
        },
        padding: {
          bottom: 20
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            const subtotal = context.parsed.y / 1.16;
            const total = context.parsed.y;
            return [
              `${label}${new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 0
              }).format(subtotal)}`,
              `+ IVA = ${new Intl.NumberFormat('es-MX', {
                style: 'currency',
                currency: 'MXN',
                minimumFractionDigits: 0
              }).format(total)}`
            ];
          }
        }
      }

    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          borderDash: [2, 2],
          color: 'rgba(0, 0, 0, 0.05)'
        },
        ticks: {
          callback: function(value) {
            return new Intl.NumberFormat('es-MX', {
              style: 'currency',
              currency: 'MXN',
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(value);
          }
        }
      }
    }
  };

  return (
    <div style={{ height: '350px', width: '100%' }}>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default SalesComparisonChart;
